/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useEffect, useRef } from 'react';
import { Badge, Heading } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { badgeTheme, ItemsPerPageBadges } from './EnhancedTableToolbarCommon';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';
import EnhancedToolbarStyles from '../../../styles/EnhancedDataTable/EnhancedTableToolbar/EnhancedTableToolbar';

const ItemsPerPageComponent = React.memo((props) => {
  const {
    onItemsPerPageChange,
    openPopup,
    setOpenPopup,
  } = props;

  const context = useEnhancedDataTableContext();

  const wrapperRef = useRef(null);
  const { itemsPerPage } = context;
  const { currentPage } = context;
  const { tableNm } = context;
  const { resultsLabel = 'Result' } = context;

  const {
    totalRows,
    itemInCurrentPage,
  } = props;

  const onPageChange = (newItemPerPage) => {
    setOpenPopup(false);
    const maxPage = Math.ceil(totalRows / newItemPerPage);
    const newPageNum = currentPage > maxPage ? maxPage : currentPage;
    if (itemsPerPage !== newItemPerPage) {
      onItemsPerPageChange(newItemPerPage, newPageNum);
    }
  };

  useEffect(() => {
    /**
     * if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenPopup(false);
      }
    }

    // Bind the event listener only if Popup is open
    if (openPopup === true) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openPopup]);

  return (
    <div
      id={`${tableNm}-itemsPerPage-component`}
      style={{
        display: 'inline-block',
        position: 'relative',
        marginTop: '25px',
      }}
    >
      <Heading
        id={`${tableNm}-itemsPerPage-pre-text`}
        level={4}
        headingStyle="heading3"
        css={EnhancedToolbarStyles['.itemsPerPageText']}
      >{resultsLabel}
      </Heading>
      <Badge
        id={`${tableNm}-itemsPerPage-current-badge`}
        css={EnhancedToolbarStyles['.itemsPerPageBadge']}
        theme={badgeTheme(true)}
        style={{ marginTop: -2 }}
        onClick={() => setOpenPopup(!openPopup)}
      >{itemInCurrentPage}
      </Badge>
      <div
        style={{
          visibility: openPopup ? 'visible' : 'hidden',
          opacity: openPopup ? '1' : '0',
          zIndex: '1',
          marginTop: -7,
          width: '200px',
        }}
        ref={wrapperRef}
        css={EnhancedToolbarStyles['.itemsPerPagePopup']}
        id={`${tableNm}-itemsPerPage-current-popup`}
      >
        <ItemsPerPageBadges
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={onPageChange}
        />
      </div>
      <Heading
        level={4}
        headingStyle="heading3"
        css={EnhancedToolbarStyles['.itemsPerPageText']}
        id={`${tableNm}-itemsPerPage-total-count`}
      >/ {totalRows}
      </Heading>
    </div>
  );
});

ItemsPerPageComponent.displayName = 'ItemsPerPageComponent';

ItemsPerPageComponent.propTypes = {
  onItemsPerPageChange: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
  itemInCurrentPage: PropTypes.number.isRequired,
};

export default ItemsPerPageComponent;
